/* global document, window */
import $ from 'jquery';
import './components/Embryo/EmbryoModal/EmbryoModal';

let lastScrollTop = $(document).scrollTop();
let lastTime = new Date().getTime();

$(document).ready(() => {
	const nextAnchor = $('.ar-body').find('.js-tabToggle:nth-child(1)');
	if (nextAnchor.length > 0) {
		nextAnchor.each((i, e) => { $(e).attr('data-anchorLower', ''); });
	}
});

function asideFixing(time, currentScroll) {
	const currentTime = time;

	const scrollDiff = currentScroll - lastScrollTop;
	const timeDiff = currentTime - lastTime;
	const scrollSpeed = scrollDiff / timeDiff;

	if ($('.js-articleAside').length > 0) {
		let prevAnchor = null;
		let nextAnchor = null;

		$('.ar-aside [href^="#"]').each((i, el) => {
			const identificator = el.hash;
			const target = $(`.ar-body ${identificator}`)[0] || $(`.ar-body [href="${identificator}"]`)[0];
			if (target) {
				const posTop = $(target).offset().top;
				if (posTop < currentScroll) {
					prevAnchor = $(el);
				}
				if (prevAnchor && posTop > currentScroll) {
					if (i === (prevAnchor.index() + 1)) {
						nextAnchor = $(el);
					}
				} else if (posTop > currentScroll) {
					if (nextAnchor) {
						nextAnchor = i > nextAnchor.index() ? nextAnchor : $(el);
					} else {
						nextAnchor = $(el);
					}
				}
			}
		});

		const el = $('.js-articleAside');
		const parentTop = el.parent().offset().top;
		const parentDown = el.parent().offset().top + el.parent().innerHeight() - el.outerHeight(true);
		if (currentScroll < parentTop) {
			el.addClass('keep-up');
		} else {
			el.removeClass('keep-up');
		}
		if (currentScroll > parentDown) {
			el.addClass('keep-down');
		} else {
			el.removeClass('keep-down');
		}
		if (currentScroll > lastScrollTop && nextAnchor) {
			$('.ar-aside .anchor-in-view').removeClass('anchor-in-view');
			nextAnchor.addClass('anchor-in-view');
		} else if (currentScroll < lastScrollTop && prevAnchor) {
			$('.ar-aside .anchor-in-view').removeClass('anchor-in-view');
			prevAnchor.addClass('anchor-in-view');
		}

		const scrollInArticle = currentScroll - $('.ar-main').offset().top;
		const asideScrollHeight = el.find('.custom-scrollbar')[0].scrollHeight;
		if (currentScroll > lastScrollTop && scrollInArticle < $('.ar-main').outerHeight()) {
			if ((scrollInArticle + (asideScrollHeight - el.find('.custom-scrollbar').scrollTop())) > $('.ar-main').outerHeight()) {
				const scrollableAsideHeight = scrollInArticle - ($('.ar-main').outerHeight() - asideScrollHeight);
				el.find('.custom-scrollbar').animate({
					scrollTop: scrollableAsideHeight,
				}, Math.abs(scrollSpeed));
			}
		} else if (scrollInArticle < el.find('.custom-scrollbar').scrollTop() && scrollInArticle > 0) {
			const scrollableAsideHeight = scrollInArticle;
			el.find('.custom-scrollbar').animate({
				scrollTop: scrollableAsideHeight,
			}, Math.abs(scrollSpeed));
		}
	}
	lastTime = currentTime;
}

$(document).on('scroll', (e) => {
	const currentScroll = $(document).scrollTop();
	asideFixing(e.timeStamp, currentScroll);
	lastScrollTop = currentScroll;
});

$(window).bind('load resize', (e) => {
	const currentScroll = $(document).scrollTop();
	asideFixing(e.timeStamp, currentScroll);
});

$('a[href^="#"]').click((e) => {
	e.preventDefault();
	if ($(e.target).attr('href') !== '#' && !$(e.target).hasClass('js-tabToggle') && $($(e.target).attr('href')).length > 0) {
		$('html, body').animate({ scrollTop: $($(e.target).attr('href')).offset().top - 100 }, 500);
	}
});
$('.grades-point').hover(() => {
	$('.grades-point__upper.is-pulsing').removeClass('is-pulsing');
	$('.grades-point.is-open').removeClass('is-open');
});



// WEBPACK FOOTER //
// ./frontend/articles.js